module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "autocomplete-input"
  }, [_c('div', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.local_keyword),
      expression: "local_keyword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm._f("translate")('Write here the breed')
    },
    domProps: {
      "value": (_vm.local_keyword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.local_keyword = $event.target.value
      }, function($event) {
        _vm.onInput($event.target.value)
      }],
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.isOpen = false
      },
      "click": _vm.click,
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.moveDown($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.moveUp($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.select($event)
      }]
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "autocomlete-items"
  }, _vm._l((_vm.fOptions), function(option, index) {
    return _c('div', {
      staticClass: "autocomlete-item",
      class: {
        'highlighted': index === _vm.highlightedPosition
      },
      on: {
        "mouseenter": function($event) {
          _vm.highlightedPosition = index
        },
        "mousedown": _vm.select
      }
    }, [_c('img', {
      attrs: {
        "alt": option.title,
        "src": option.rasa_obrazek_small_url ? option.rasa_obrazek_small_url : _vm.raceSmallImagesUrl + option.title_en + '.png'
      }
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(option.title) + " "), (option.slang.length > 0) ? _c('span', {
      staticClass: "slang"
    }, [_vm._v("(" + _vm._s(option.slang) + ")")]) : _vm._e()])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51db148a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Autocomplete.vue
// module id = 549
// module chunks = 1